import * as React from "react";

import { cn } from "../../lib/utils";

/**
 * Presentational rule. Rendered as a plain div rather than a Radix separator
 * because every use here is decorative — the list already has semantic
 * structure — and it keeps one more primitive out of the bundle.
 */
const Separator = React.forwardRef(
  ({ className, orientation = "horizontal", ...props }, ref) => (
    <div
      ref={ref}
      role="none"
      className={cn(
        "shrink-0 bg-border",
        orientation === "horizontal" ? "h-px w-full" : "h-full w-px",
        className
      )}
      {...props}
    />
  )
);
Separator.displayName = "Separator";

export { Separator };
